// source: pbtypes/tools/iot_api/dock_iot.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var pbtypes_gen_dock_dock_status_pb = require('../../../pbtypes/gen/dock/dock_status_pb.js');
goog.object.extend(proto, pbtypes_gen_dock_dock_status_pb);
var pbtypes_gen_health_monitor_active_fault_ids_pb = require('../../../pbtypes/gen/health_monitor/active_fault_ids_pb.js');
goog.object.extend(proto, pbtypes_gen_health_monitor_active_fault_ids_pb);
var pbtypes_tools_cloud_api_release_pb = require('../../../pbtypes/tools/cloud_api/release_pb.js');
goog.object.extend(proto, pbtypes_tools_cloud_api_release_pb);
var pbtypes_tools_iot_api_web_tunnel_pb = require('../../../pbtypes/tools/iot_api/web_tunnel_pb.js');
goog.object.extend(proto, pbtypes_tools_iot_api_web_tunnel_pb);
var pbtypes_vehicle_ambassador_ambassador_pb = require('../../../pbtypes/vehicle/ambassador/ambassador_pb.js');
goog.object.extend(proto, pbtypes_vehicle_ambassador_ambassador_pb);
var pbtypes_vehicle_infrastructure_flight_deck_status_pb = require('../../../pbtypes/vehicle/infrastructure/flight_deck/status_pb.js');
goog.object.extend(proto, pbtypes_vehicle_infrastructure_flight_deck_status_pb);
var pbtypes_infrastructure_remote_streaming_livekit_streaming_pb = require('../../../pbtypes/infrastructure/remote_streaming/livekit_streaming_pb.js');
goog.object.extend(proto, pbtypes_infrastructure_remote_streaming_livekit_streaming_pb);
var pbtypes_util_flag_util_flag_hoist_pb = require('../../../pbtypes/util/flag_util/flag_hoist_pb.js');
goog.object.extend(proto, pbtypes_util_flag_util_flag_hoist_pb);
var pbtypes_tools_iot_api_device_iot_pb = require('../../../pbtypes/tools/iot_api/device_iot_pb.js');
goog.object.extend(proto, pbtypes_tools_iot_api_device_iot_pb);
var pbtypes_infrastructure_drivers_weather_station_weather_station_pb = require('../../../pbtypes/infrastructure/drivers/weather_station/weather_station_pb.js');
goog.object.extend(proto, pbtypes_infrastructure_drivers_weather_station_weather_station_pb);
var pbtypes_gen_adsb_rx_adsb_traffic_pb = require('../../../pbtypes/gen/adsb_rx/adsb_traffic_pb.js');
goog.object.extend(proto, pbtypes_gen_adsb_rx_adsb_traffic_pb);
var pbtypes_infrastructure_traffic_control_traffic_control_pb = require('../../../pbtypes/infrastructure/traffic_control/traffic_control_pb.js');
goog.object.extend(proto, pbtypes_infrastructure_traffic_control_traffic_control_pb);
goog.exportSymbol('proto.iot_api.DockIOTDesiredState', null, global);
goog.exportSymbol('proto.iot_api.DockIOTStatus', null, global);
goog.exportSymbol('proto.iot_api.DockIOTStatus.ConnectedSensor', null, global);
goog.exportSymbol('proto.iot_api.SensorType', null, global);
goog.exportSymbol('proto.iot_api.SensorType.Enum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DockIOTStatus = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.iot_api.DockIOTStatus.repeatedFields_, null);
};
goog.inherits(proto.iot_api.DockIOTStatus, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DockIOTStatus.displayName = 'proto.iot_api.DockIOTStatus';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DockIOTStatus.ConnectedSensor = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.DockIOTStatus.ConnectedSensor, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DockIOTStatus.ConnectedSensor.displayName = 'proto.iot_api.DockIOTStatus.ConnectedSensor';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.DockIOTDesiredState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.DockIOTDesiredState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.DockIOTDesiredState.displayName = 'proto.iot_api.DockIOTDesiredState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.iot_api.SensorType = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.iot_api.SensorType, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.iot_api.SensorType.displayName = 'proto.iot_api.SensorType';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.iot_api.DockIOTStatus.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DockIOTStatus.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DockIOTStatus.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DockIOTStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DockIOTStatus.toObject = function(includeInstance, msg) {
  var f, obj = {
uclock: jspb.Message.getFieldWithDefault(msg, 1, 0),
bootId: jspb.Message.getFieldWithDefault(msg, 5, ""),
webTunnelUptimeUsec: jspb.Message.getFieldWithDefault(msg, 16, 0),
dockStatus: (f = msg.getDockStatus()) && pbtypes_gen_dock_dock_status_pb.DockStatus.toObject(includeInstance, f),
gps: (f = msg.getGps()) && pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps.toObject(includeInstance, f),
flightDeckStatus: (f = msg.getFlightDeckStatus()) && pbtypes_vehicle_infrastructure_flight_deck_status_pb.Status.toObject(includeInstance, f),
pendingReleaseUpdate: (f = msg.getPendingReleaseUpdate()) && pbtypes_tools_cloud_api_release_pb.ReleaseFile.toObject(includeInstance, f),
livekitConnectionStatus: (f = msg.getLivekitConnectionStatus()) && pbtypes_infrastructure_remote_streaming_livekit_streaming_pb.LivekitConnectionStatus.toObject(includeInstance, f),
hyperMastFlags: (f = msg.getHyperMastFlags()) && pbtypes_util_flag_util_flag_hoist_pb.EncodedFlags.toObject(includeInstance, f),
networkTestResult: (f = msg.getNetworkTestResult()) && pbtypes_tools_iot_api_device_iot_pb.DeviceNetworkTestSuiteResult.toObject(includeInstance, f),
activeFaultIds: (f = msg.getActiveFaultIds()) && pbtypes_gen_health_monitor_active_fault_ids_pb.ActiveFaultIds.toObject(includeInstance, f),
connectedSensorsList: jspb.Message.toObjectList(msg.getConnectedSensorsList(),
    proto.iot_api.DockIOTStatus.ConnectedSensor.toObject, includeInstance),
weatherStationData: (f = msg.getWeatherStationData()) && pbtypes_infrastructure_drivers_weather_station_weather_station_pb.WeatherStationData.toObject(includeInstance, f),
adsbTraffic: (f = msg.getAdsbTraffic()) && pbtypes_gen_adsb_rx_adsb_traffic_pb.AdsbTraffic.toObject(includeInstance, f),
trafficControlStatus: (f = msg.getTrafficControlStatus()) && pbtypes_infrastructure_traffic_control_traffic_control_pb.TrafficControlStatus.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DockIOTStatus}
 */
proto.iot_api.DockIOTStatus.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DockIOTStatus;
  return proto.iot_api.DockIOTStatus.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DockIOTStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DockIOTStatus}
 */
proto.iot_api.DockIOTStatus.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUclock(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBootId(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setWebTunnelUptimeUsec(value);
      break;
    case 2:
      var value = new pbtypes_gen_dock_dock_status_pb.DockStatus;
      reader.readMessage(value,pbtypes_gen_dock_dock_status_pb.DockStatus.deserializeBinaryFromReader);
      msg.setDockStatus(value);
      break;
    case 4:
      var value = new pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps;
      reader.readMessage(value,pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps.deserializeBinaryFromReader);
      msg.setGps(value);
      break;
    case 6:
      var value = new pbtypes_vehicle_infrastructure_flight_deck_status_pb.Status;
      reader.readMessage(value,pbtypes_vehicle_infrastructure_flight_deck_status_pb.Status.deserializeBinaryFromReader);
      msg.setFlightDeckStatus(value);
      break;
    case 7:
      var value = new pbtypes_tools_cloud_api_release_pb.ReleaseFile;
      reader.readMessage(value,pbtypes_tools_cloud_api_release_pb.ReleaseFile.deserializeBinaryFromReader);
      msg.setPendingReleaseUpdate(value);
      break;
    case 8:
      var value = new pbtypes_infrastructure_remote_streaming_livekit_streaming_pb.LivekitConnectionStatus;
      reader.readMessage(value,pbtypes_infrastructure_remote_streaming_livekit_streaming_pb.LivekitConnectionStatus.deserializeBinaryFromReader);
      msg.setLivekitConnectionStatus(value);
      break;
    case 9:
      var value = new pbtypes_util_flag_util_flag_hoist_pb.EncodedFlags;
      reader.readMessage(value,pbtypes_util_flag_util_flag_hoist_pb.EncodedFlags.deserializeBinaryFromReader);
      msg.setHyperMastFlags(value);
      break;
    case 10:
      var value = new pbtypes_tools_iot_api_device_iot_pb.DeviceNetworkTestSuiteResult;
      reader.readMessage(value,pbtypes_tools_iot_api_device_iot_pb.DeviceNetworkTestSuiteResult.deserializeBinaryFromReader);
      msg.setNetworkTestResult(value);
      break;
    case 11:
      var value = new pbtypes_gen_health_monitor_active_fault_ids_pb.ActiveFaultIds;
      reader.readMessage(value,pbtypes_gen_health_monitor_active_fault_ids_pb.ActiveFaultIds.deserializeBinaryFromReader);
      msg.setActiveFaultIds(value);
      break;
    case 12:
      var value = new proto.iot_api.DockIOTStatus.ConnectedSensor;
      reader.readMessage(value,proto.iot_api.DockIOTStatus.ConnectedSensor.deserializeBinaryFromReader);
      msg.addConnectedSensors(value);
      break;
    case 13:
      var value = new pbtypes_infrastructure_drivers_weather_station_weather_station_pb.WeatherStationData;
      reader.readMessage(value,pbtypes_infrastructure_drivers_weather_station_weather_station_pb.WeatherStationData.deserializeBinaryFromReader);
      msg.setWeatherStationData(value);
      break;
    case 14:
      var value = new pbtypes_gen_adsb_rx_adsb_traffic_pb.AdsbTraffic;
      reader.readMessage(value,pbtypes_gen_adsb_rx_adsb_traffic_pb.AdsbTraffic.deserializeBinaryFromReader);
      msg.setAdsbTraffic(value);
      break;
    case 15:
      var value = new pbtypes_infrastructure_traffic_control_traffic_control_pb.TrafficControlStatus;
      reader.readMessage(value,pbtypes_infrastructure_traffic_control_traffic_control_pb.TrafficControlStatus.deserializeBinaryFromReader);
      msg.setTrafficControlStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DockIOTStatus.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DockIOTStatus.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DockIOTStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DockIOTStatus.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUclock();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getBootId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getWebTunnelUptimeUsec();
  if (f !== 0) {
    writer.writeUint64(
      16,
      f
    );
  }
  f = message.getDockStatus();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_dock_dock_status_pb.DockStatus.serializeBinaryToWriter
    );
  }
  f = message.getGps();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps.serializeBinaryToWriter
    );
  }
  f = message.getFlightDeckStatus();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_vehicle_infrastructure_flight_deck_status_pb.Status.serializeBinaryToWriter
    );
  }
  f = message.getPendingReleaseUpdate();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      pbtypes_tools_cloud_api_release_pb.ReleaseFile.serializeBinaryToWriter
    );
  }
  f = message.getLivekitConnectionStatus();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      pbtypes_infrastructure_remote_streaming_livekit_streaming_pb.LivekitConnectionStatus.serializeBinaryToWriter
    );
  }
  f = message.getHyperMastFlags();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      pbtypes_util_flag_util_flag_hoist_pb.EncodedFlags.serializeBinaryToWriter
    );
  }
  f = message.getNetworkTestResult();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      pbtypes_tools_iot_api_device_iot_pb.DeviceNetworkTestSuiteResult.serializeBinaryToWriter
    );
  }
  f = message.getActiveFaultIds();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      pbtypes_gen_health_monitor_active_fault_ids_pb.ActiveFaultIds.serializeBinaryToWriter
    );
  }
  f = message.getConnectedSensorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.iot_api.DockIOTStatus.ConnectedSensor.serializeBinaryToWriter
    );
  }
  f = message.getWeatherStationData();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      pbtypes_infrastructure_drivers_weather_station_weather_station_pb.WeatherStationData.serializeBinaryToWriter
    );
  }
  f = message.getAdsbTraffic();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      pbtypes_gen_adsb_rx_adsb_traffic_pb.AdsbTraffic.serializeBinaryToWriter
    );
  }
  f = message.getTrafficControlStatus();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      pbtypes_infrastructure_traffic_control_traffic_control_pb.TrafficControlStatus.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DockIOTStatus.ConnectedSensor.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DockIOTStatus.ConnectedSensor} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.toObject = function(includeInstance, msg) {
  var f, obj = {
sensorSerial: jspb.Message.getFieldWithDefault(msg, 1, ""),
sensorType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DockIOTStatus.ConnectedSensor}
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DockIOTStatus.ConnectedSensor;
  return proto.iot_api.DockIOTStatus.ConnectedSensor.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DockIOTStatus.ConnectedSensor} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DockIOTStatus.ConnectedSensor}
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSensorSerial(value);
      break;
    case 2:
      var value = /** @type {!proto.iot_api.SensorType.Enum} */ (reader.readEnum());
      msg.setSensorType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DockIOTStatus.ConnectedSensor.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DockIOTStatus.ConnectedSensor} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSensorSerial();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSensorType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string sensor_serial = 1;
 * @return {string}
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.prototype.getSensorSerial = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DockIOTStatus.ConnectedSensor} returns this
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.prototype.setSensorSerial = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SensorType.Enum sensor_type = 2;
 * @return {!proto.iot_api.SensorType.Enum}
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.prototype.getSensorType = function() {
  return /** @type {!proto.iot_api.SensorType.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.iot_api.SensorType.Enum} value
 * @return {!proto.iot_api.DockIOTStatus.ConnectedSensor} returns this
 */
proto.iot_api.DockIOTStatus.ConnectedSensor.prototype.setSensorType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional uint64 uclock = 1;
 * @return {number}
 */
proto.iot_api.DockIOTStatus.prototype.getUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.setUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string boot_id = 5;
 * @return {string}
 */
proto.iot_api.DockIOTStatus.prototype.getBootId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.setBootId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint64 web_tunnel_uptime_usec = 16;
 * @return {number}
 */
proto.iot_api.DockIOTStatus.prototype.getWebTunnelUptimeUsec = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.setWebTunnelUptimeUsec = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional dock.DockStatus dock_status = 2;
 * @return {?proto.dock.DockStatus}
 */
proto.iot_api.DockIOTStatus.prototype.getDockStatus = function() {
  return /** @type{?proto.dock.DockStatus} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_dock_dock_status_pb.DockStatus, 2));
};


/**
 * @param {?proto.dock.DockStatus|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setDockStatus = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearDockStatus = function() {
  return this.setDockStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasDockStatus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ambassador.MinimalGps gps = 4;
 * @return {?proto.ambassador.MinimalGps}
 */
proto.iot_api.DockIOTStatus.prototype.getGps = function() {
  return /** @type{?proto.ambassador.MinimalGps} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_ambassador_ambassador_pb.MinimalGps, 4));
};


/**
 * @param {?proto.ambassador.MinimalGps|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setGps = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearGps = function() {
  return this.setGps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasGps = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional flight_deck.Status flight_deck_status = 6;
 * @return {?proto.flight_deck.Status}
 */
proto.iot_api.DockIOTStatus.prototype.getFlightDeckStatus = function() {
  return /** @type{?proto.flight_deck.Status} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_infrastructure_flight_deck_status_pb.Status, 6));
};


/**
 * @param {?proto.flight_deck.Status|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setFlightDeckStatus = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearFlightDeckStatus = function() {
  return this.setFlightDeckStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasFlightDeckStatus = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional cloud_api.ReleaseFile pending_release_update = 7;
 * @return {?proto.cloud_api.ReleaseFile}
 */
proto.iot_api.DockIOTStatus.prototype.getPendingReleaseUpdate = function() {
  return /** @type{?proto.cloud_api.ReleaseFile} */ (
    jspb.Message.getWrapperField(this, pbtypes_tools_cloud_api_release_pb.ReleaseFile, 7));
};


/**
 * @param {?proto.cloud_api.ReleaseFile|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setPendingReleaseUpdate = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearPendingReleaseUpdate = function() {
  return this.setPendingReleaseUpdate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasPendingReleaseUpdate = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional remote_streaming.LivekitConnectionStatus livekit_connection_status = 8;
 * @return {?proto.remote_streaming.LivekitConnectionStatus}
 */
proto.iot_api.DockIOTStatus.prototype.getLivekitConnectionStatus = function() {
  return /** @type{?proto.remote_streaming.LivekitConnectionStatus} */ (
    jspb.Message.getWrapperField(this, pbtypes_infrastructure_remote_streaming_livekit_streaming_pb.LivekitConnectionStatus, 8));
};


/**
 * @param {?proto.remote_streaming.LivekitConnectionStatus|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setLivekitConnectionStatus = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearLivekitConnectionStatus = function() {
  return this.setLivekitConnectionStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasLivekitConnectionStatus = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional flag_util.flag_hoist.EncodedFlags hyper_mast_flags = 9;
 * @return {?proto.flag_util.flag_hoist.EncodedFlags}
 */
proto.iot_api.DockIOTStatus.prototype.getHyperMastFlags = function() {
  return /** @type{?proto.flag_util.flag_hoist.EncodedFlags} */ (
    jspb.Message.getWrapperField(this, pbtypes_util_flag_util_flag_hoist_pb.EncodedFlags, 9));
};


/**
 * @param {?proto.flag_util.flag_hoist.EncodedFlags|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setHyperMastFlags = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearHyperMastFlags = function() {
  return this.setHyperMastFlags(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasHyperMastFlags = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional DeviceNetworkTestSuiteResult network_test_result = 10;
 * @return {?proto.iot_api.DeviceNetworkTestSuiteResult}
 */
proto.iot_api.DockIOTStatus.prototype.getNetworkTestResult = function() {
  return /** @type{?proto.iot_api.DeviceNetworkTestSuiteResult} */ (
    jspb.Message.getWrapperField(this, pbtypes_tools_iot_api_device_iot_pb.DeviceNetworkTestSuiteResult, 10));
};


/**
 * @param {?proto.iot_api.DeviceNetworkTestSuiteResult|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setNetworkTestResult = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearNetworkTestResult = function() {
  return this.setNetworkTestResult(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasNetworkTestResult = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional health_monitor.ActiveFaultIds active_fault_ids = 11;
 * @return {?proto.health_monitor.ActiveFaultIds}
 */
proto.iot_api.DockIOTStatus.prototype.getActiveFaultIds = function() {
  return /** @type{?proto.health_monitor.ActiveFaultIds} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_health_monitor_active_fault_ids_pb.ActiveFaultIds, 11));
};


/**
 * @param {?proto.health_monitor.ActiveFaultIds|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setActiveFaultIds = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearActiveFaultIds = function() {
  return this.setActiveFaultIds(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasActiveFaultIds = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated ConnectedSensor connected_sensors = 12;
 * @return {!Array<!proto.iot_api.DockIOTStatus.ConnectedSensor>}
 */
proto.iot_api.DockIOTStatus.prototype.getConnectedSensorsList = function() {
  return /** @type{!Array<!proto.iot_api.DockIOTStatus.ConnectedSensor>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.iot_api.DockIOTStatus.ConnectedSensor, 12));
};


/**
 * @param {!Array<!proto.iot_api.DockIOTStatus.ConnectedSensor>} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setConnectedSensorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.iot_api.DockIOTStatus.ConnectedSensor=} opt_value
 * @param {number=} opt_index
 * @return {!proto.iot_api.DockIOTStatus.ConnectedSensor}
 */
proto.iot_api.DockIOTStatus.prototype.addConnectedSensors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.iot_api.DockIOTStatus.ConnectedSensor, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearConnectedSensorsList = function() {
  return this.setConnectedSensorsList([]);
};


/**
 * optional weather_station.WeatherStationData weather_station_data = 13;
 * @return {?proto.weather_station.WeatherStationData}
 */
proto.iot_api.DockIOTStatus.prototype.getWeatherStationData = function() {
  return /** @type{?proto.weather_station.WeatherStationData} */ (
    jspb.Message.getWrapperField(this, pbtypes_infrastructure_drivers_weather_station_weather_station_pb.WeatherStationData, 13));
};


/**
 * @param {?proto.weather_station.WeatherStationData|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setWeatherStationData = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearWeatherStationData = function() {
  return this.setWeatherStationData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasWeatherStationData = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional adsb_rx.AdsbTraffic adsb_traffic = 14;
 * @return {?proto.adsb_rx.AdsbTraffic}
 */
proto.iot_api.DockIOTStatus.prototype.getAdsbTraffic = function() {
  return /** @type{?proto.adsb_rx.AdsbTraffic} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_adsb_rx_adsb_traffic_pb.AdsbTraffic, 14));
};


/**
 * @param {?proto.adsb_rx.AdsbTraffic|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setAdsbTraffic = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearAdsbTraffic = function() {
  return this.setAdsbTraffic(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasAdsbTraffic = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional traffic_control.TrafficControlStatus traffic_control_status = 15;
 * @return {?proto.traffic_control.TrafficControlStatus}
 */
proto.iot_api.DockIOTStatus.prototype.getTrafficControlStatus = function() {
  return /** @type{?proto.traffic_control.TrafficControlStatus} */ (
    jspb.Message.getWrapperField(this, pbtypes_infrastructure_traffic_control_traffic_control_pb.TrafficControlStatus, 15));
};


/**
 * @param {?proto.traffic_control.TrafficControlStatus|undefined} value
 * @return {!proto.iot_api.DockIOTStatus} returns this
*/
proto.iot_api.DockIOTStatus.prototype.setTrafficControlStatus = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTStatus} returns this
 */
proto.iot_api.DockIOTStatus.prototype.clearTrafficControlStatus = function() {
  return this.setTrafficControlStatus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTStatus.prototype.hasTrafficControlStatus = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.DockIOTDesiredState.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.DockIOTDesiredState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.DockIOTDesiredState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DockIOTDesiredState.toObject = function(includeInstance, msg) {
  var f, obj = {
uclock: jspb.Message.getFieldWithDefault(msg, 1, 0),
connectWebrtc: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
bootId: jspb.Message.getFieldWithDefault(msg, 4, ""),
exposeWebTunnel: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
webTunnelParams: (f = msg.getWebTunnelParams()) && pbtypes_tools_iot_api_web_tunnel_pb.ServerWebTunnelParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.DockIOTDesiredState}
 */
proto.iot_api.DockIOTDesiredState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.DockIOTDesiredState;
  return proto.iot_api.DockIOTDesiredState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.DockIOTDesiredState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.DockIOTDesiredState}
 */
proto.iot_api.DockIOTDesiredState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUclock(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setConnectWebrtc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBootId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExposeWebTunnel(value);
      break;
    case 3:
      var value = new pbtypes_tools_iot_api_web_tunnel_pb.ServerWebTunnelParams;
      reader.readMessage(value,pbtypes_tools_iot_api_web_tunnel_pb.ServerWebTunnelParams.deserializeBinaryFromReader);
      msg.setWebTunnelParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.DockIOTDesiredState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.DockIOTDesiredState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.DockIOTDesiredState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.DockIOTDesiredState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUclock();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getConnectWebrtc();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getBootId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getExposeWebTunnel();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getWebTunnelParams();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_tools_iot_api_web_tunnel_pb.ServerWebTunnelParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 uclock = 1;
 * @return {number}
 */
proto.iot_api.DockIOTDesiredState.prototype.getUclock = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.iot_api.DockIOTDesiredState} returns this
 */
proto.iot_api.DockIOTDesiredState.prototype.setUclock = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool connect_webrtc = 5;
 * @return {boolean}
 */
proto.iot_api.DockIOTDesiredState.prototype.getConnectWebrtc = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.iot_api.DockIOTDesiredState} returns this
 */
proto.iot_api.DockIOTDesiredState.prototype.setConnectWebrtc = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional string boot_id = 4;
 * @return {string}
 */
proto.iot_api.DockIOTDesiredState.prototype.getBootId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.iot_api.DockIOTDesiredState} returns this
 */
proto.iot_api.DockIOTDesiredState.prototype.setBootId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional bool expose_web_tunnel = 2;
 * @return {boolean}
 */
proto.iot_api.DockIOTDesiredState.prototype.getExposeWebTunnel = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.iot_api.DockIOTDesiredState} returns this
 */
proto.iot_api.DockIOTDesiredState.prototype.setExposeWebTunnel = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional ServerWebTunnelParams web_tunnel_params = 3;
 * @return {?proto.iot_api.ServerWebTunnelParams}
 */
proto.iot_api.DockIOTDesiredState.prototype.getWebTunnelParams = function() {
  return /** @type{?proto.iot_api.ServerWebTunnelParams} */ (
    jspb.Message.getWrapperField(this, pbtypes_tools_iot_api_web_tunnel_pb.ServerWebTunnelParams, 3));
};


/**
 * @param {?proto.iot_api.ServerWebTunnelParams|undefined} value
 * @return {!proto.iot_api.DockIOTDesiredState} returns this
*/
proto.iot_api.DockIOTDesiredState.prototype.setWebTunnelParams = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.iot_api.DockIOTDesiredState} returns this
 */
proto.iot_api.DockIOTDesiredState.prototype.clearWebTunnelParams = function() {
  return this.setWebTunnelParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.iot_api.DockIOTDesiredState.prototype.hasWebTunnelParams = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.iot_api.SensorType.prototype.toObject = function(opt_includeInstance) {
  return proto.iot_api.SensorType.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.iot_api.SensorType} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.SensorType.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.iot_api.SensorType}
 */
proto.iot_api.SensorType.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.iot_api.SensorType;
  return proto.iot_api.SensorType.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.iot_api.SensorType} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.iot_api.SensorType}
 */
proto.iot_api.SensorType.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.iot_api.SensorType.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.iot_api.SensorType.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.iot_api.SensorType} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.iot_api.SensorType.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.iot_api.SensorType.Enum = {
  UNKNOWN: 0,
  WEATHER: 1,
  ADS_B: 2
};

goog.object.extend(exports, proto.iot_api);
